import { Card, CardContent, CardHeader, CardTitle } from '@/components/shadcn/card'
import { Separator } from '@/components/shadcn/separator'

interface Props {
  title: string
  chart: React.ReactNode
  controls: React.ReactNode
}

export function ChartCard({ title, chart, controls }: Props) {
  return (
    <Card className="flex flex-col h-120">
      <CardHeader>
        <CardTitle className="text-foreground">{title}</CardTitle>
      </CardHeader>
      <CardContent className="flex-1 flex flex-col gap-4">
        <div className="flex-1">{chart}</div>
        <Separator/>
        {controls}
      </CardContent>
    </Card>
  )
}
